export default __webpack_public_path__ + "media/images/fonts/glyphicons-halflings-regular-448c34a56d699c29117adc64c43affeb.woff2";